/** @jsxImportSource @emotion/react */
import { css, SerializedStyles } from "@emotion/react";
import {
  DisclosureButton,
  Disclosure as D,
  DisclosurePanel,
} from "@headlessui/react";
import { Fragment } from "react";

type Props = {
  renderButton: (open: boolean) => React.ReactNode;
  children: React.ReactNode;
  wrapperStyles?: SerializedStyles;
};

const panelStyle = css`
  transform-origin: top;
  transition: transform 0.2s ease-out, opacity 0.2s ease-out;
  &[data-closed] {
    transform: translateY(-6px);
    opacity: 0;
  }
`;

export const Disclosure = ({
  renderButton,
  children,
  wrapperStyles,
}: Props) => {
  return (
    <D>
      {({ open }) => (
        <div css={wrapperStyles}>
          <DisclosureButton as={Fragment}>
            {renderButton(open)}
          </DisclosureButton>
          <DisclosurePanel transition css={panelStyle}>
            {children}
          </DisclosurePanel>
        </div>
      )}
    </D>
  );
};
